<template>
    <section>
        <PageTitle title="All Complaints" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/complaints',title:'complaints'}]" />
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="ibox-content">
                <div class="row">
                    <div class="col-md-3" v-if="userRole !== 'ROLE_USER' ">
                        <div class="form-group">
                            <label>Warehouse</label>
                            <multiselect id="filter1" v-model="selectedRestaurant" :options="allRestaurants" label="name" track-by="name" ></multiselect>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Complaint Status</label>
                            <multiselect id="filter2" v-model="selectedOrderStatus" :options="allOrderStatus" ></multiselect>
                        </div>
                    </div>
                    <div class="col-md-3 form-group">
                        <label>Complainant Number</label>
                        <input v-model="callerNumber"
                               class="form-control"
                               id="phone_num"
                               type="text"
                               pattern="^(0|\+)[1-9]*[0-9]{10,}$"
                               size="11"
                               placeholder="0xxxxxxxxxxx or +xxxxxxxxxxx"/>
                    </div>
                    <div class="col-md-3 form-group">
                      <label>Order Id</label>
                      <input v-model="orderId" type="number" placeholder="Order Id..." class="form-control" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <button style="margin-top: 10px;margin-right: 10px" class="m-b btn btn-primary btn-sm search_filter_order_btn"><i class="fa fa-search"></i> Search</button>
                        <button style="margin-top: 10px" class="m-b btn btn-info btn-sm refresh_filter_order_btn"><i class="fa fa-refresh"></i> Refresh</button>
                    </div>
                </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="ibox-title">
                        <h5 class="pull-left">All Complaints</h5>
                        <a class="pull-right" v-on:click="loadGenericComplaintModal()">Register New Complaint</a>
                    </div>
                    <div class="ibox-content">
                        <div class="table-responsive">
                            <table class="table table-striped table-bordered table-hover" id="dtTable">
                                <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Complaint</th>
                                    <th>Complainant Name</th>
                                    <th>Complainant Number</th>
                                    <th>Register by</th>
                                    <th>Order #</th>
                                    <th>Warehouse</th>
                                    <th>Created</th>
                                    <th>Modified</th>
                                    <th>Status</th>
                                    <th v-if="userRole === 'ROLE_ADMIN'" class="text-center"><i class="fa fa-bolt"></i></th>
                                </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ViewOrder showActions="false" ref="viewOrderComp"/>
        <GenericComplaint ref="genericComplaintPopUp"/>
        <ViewComplaintDetails ref="viewComplaintDetails" complaint="complaint"/>
        </div>
    </section>
</template>

<script>
    /* eslint-disable */
    import PageTitle from '@/components/layout_components/PageTitle'
    import ViewOrder from '@/components/orders/ViewOrder'
    import GenericComplaint from '@/components/complaints/GenericComplaint'
    import ViewComplaintDetails from '@/components/complaints/ViewComplaintDetails'
    import Multiselect from 'vue-multiselect'

    export default {
        name: "Complaints",
        data() {
            return {
                userRole: "",
                callerNumber: "",
                orderId: "",
                complaint: "",
                allRestaurants: [],
                selectedRestaurant: null,
                allOrderStatus: ["NEW", "IGNORED", "RESOLVED"],
                selectedOrderStatus: null,
                dtTable: null
            }
        },
        components: {
            ViewOrder,
            PageTitle,
            GenericComplaint,
            Multiselect,
            ViewComplaintDetails
        },
        created: function () {
            let loggedInUser = this.$store.state.user;
            if(loggedInUser){
                this.userRole = loggedInUser.userRolesById[0].role;
            }
            if(this.userRole === "ROLE_ADMIN" || this.userRole === "ROLE_AGENT"){
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_all_restaurants").then(
                    resp=> {
                        this.allRestaurants = resp.data;
                    });
            }
        },
        mounted: function () {
            let self = this;
            let processingURL = this.$store.state.mainAppURL + "complaints/get_all_complaints";
          $("#phone_num").tooltip({
            trigger: 'hover',
            title: 'Length should be greater then or equal to 11 and phone number should be start with 0 or +',
            placement: 'bottom'
          });
            self.dtTable = $('#dtTable').DataTable({
                "processing": true,
                "serverSide": true,
                "dom": 'lrtip',
                "pagingType": "simple",
                "lengthMenu": [10, 25, 50, 100, 250],
                'language': {
                    //'loadingRecords': 'Please wait - loading...',
                    'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                        '                <div class="sk-double-bounce1"></div>\n' +
                        '                <div class="sk-double-bounce2"></div>\n' +
                        '              </div>'
                },
                autoWidth: false,
                "order": [[0, "desc"]],
                "ajax": {
                    url: processingURL,
                    type: "post",
                    data: function ( d ) {
                        return JSON.stringify( d );
                    },
                    headers: {
                        "Content-type": "application/json; charset=utf-8"
                    },
                    beforeSend:  (xhr) => {
                        xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
                    },
                    statusCode: {
                      401: () => {
                        this.updateRefreshTokenInDataTable(this.dtTable);
                      }
                    }
                },
                "columnDefs": [
                    { "orderable": false, "targets": [1,2,3,4,5,6,9,10] },
                    { 'className': "text-center", 'aTargets': [0,3,4,5,6,7,8,9,10]},
                    { 'visible': self.userRole === 'ROLE_ADMIN' || self.userRole === 'ROLE_USER', targets: [9]}
                ],
                "columns": [
                    { "data": "id", "name":"id" },
                    {
                        "data": "complaint","name":"complaint",
                        render: function (data) {
                          data = data.replaceAll("'", "&#39;")
                          let title = (data.length > 50) ? data.substring(0, 100) + "..." : data;
                          return "<a id='complaint_details' title='" + data + "' data-value='" + data
                              + "' class='tip_class complaint_details'>" + title + "</a>";
                        }
                    },
                    {"data": "complainantName","name":"complainantName"},
                    {"data": "complainantNumber","name":"complainantNumber"},
                    {"data": "userName","name":"userName"},
                    {
                        "data": "orderId","name":"orderId",
                        render: function (data){
                            return (data === null) ? "N/A" : "<a class='showOrderDetail'>"+data+"</a>";
                        }
                    },
                    {"data": "restaurantName","name":"restaurantName"},
                    {
                        "data": "created",
                        "name":"created",
                        "render": function (data) {
                          return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                    {
                        "data": "modified",
                        "name":"modified",
                        "render": function (data) {
                          return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                    {
                        "data": "status","name":"status",
                        "render": function(data){
                            if(data === "NEW"){
                                return "<label class='label label-default'>"+data+"</label>";
                            }
                            if(data === "RESOLVED"){
                                return "<label class='label label-success'>"+data+"</label>";
                            }
                            if(data === "IGNORED"){
                                return "<label class='label label-warning'>"+data+"</label>";
                            }
                        }
                    },
                    {
                        "data":"action", "name": "action",
                        render: function (data,type,row) {
                            return "<a data-id='"+row.id+"' class='updateComplaint'>Update</a>"
                        }
                    }
                ],
                "drawCallback": function( settings ) {
                    $(".tip_class").tooltip();
                    $(".showOrderDetail").click(function () {
                        self.$refs.viewOrderComp.fetchOrderDetail($(this).html());
                    });
                    $(".updateComplaint").click(function () {
                        self.$refs.genericComplaintPopUp.load($(this).attr("data-id"));
                    });
                    $(".tip_class.complaint_details").click(function () {
                      let complaint = $(this).attr("data-value");
                      self.$refs.viewComplaintDetails.load(complaint);
                    });
                }
            });
            $.fn.dataTable.ext.errMode = 'none';
            $(".search_filter_order_btn").click(function(){
                  if($("#phone_num").is(":invalid")){
                    swal("TRY AGAIN", "Invalid Phone Number", "error");
                  }else {
                    self.dtTable.column(3).search('');
                    self.dtTable.column(5).search('');
                    self.dtTable.column(6).search('');
                    self.dtTable.column(8).search('');
                    if (self.callerNumber)
                      self.dtTable.column(3).search(self.callerNumber);
                    if (self.selectedRestaurant !== null)
                      self.dtTable.column(5).search(self.selectedRestaurant.name);
                    if (self.selectedOrderStatus !== null)
                      self.dtTable.column(8).search(self.selectedOrderStatus);
                    if (self.orderId !== null)
                      self.dtTable.column(6).search(self.orderId);
                    self.dtTable.draw();
                  }
            });
            $(".refresh_filter_order_btn").click(function(){
                for(var i=1; i <= 10; i++){
                    if (i === 5){
                        $('.areas_select').val("").trigger('change');
                    }
                    $("#filter" + i).val( '' );
                    self.dtTable.column(i).search( '' );
                }
                self.selectedRestaurant = null;
                self.selectedOrderStatus = null;
                self.callerNumber = "";
                self.orderId = "";
                self.dtTable.draw();
              $("#phone_num").tooltip({
                trigger: 'hover',
                title: 'Length should be greater then 11 and phone number should be start with 0 or +',
                placement: 'bottom'
              });
            });
            let dtTableFilterSelector = $("#dtTable_filter input");
            dtTableFilterSelector.unbind();
            dtTableFilterSelector.attr("size","40");
            dtTableFilterSelector.attr("placeholder", "Search on name, number, warehouse or status....");
            dtTableFilterSelector.keyup(function (e) {
                if(e.keyCode === 13) {
                    self.dtTable.search($(this).val()).draw();
                }
            });
        },
        methods: {
            loadGenericComplaintModal: function () {
                this.$refs.genericComplaintPopUp.load(0);
            },
        }
    }
</script>

<style scoped>

</style>
